import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppMenu } from '../components/common/AppMenu';
import { uiClasses } from '../components/common/uiClasses';
import { FeedbackButton } from '../features/feedback/components/FeedbackButton';
import { useCookieConsent } from '../features/cookies/CookieConsentProvider';
import { PageErrorBoundary } from '../components/common/ErrorBoundary';

export function MainLayout({ children }: { children?: React.ReactNode }) {
  const { t } = useTranslation('cookies');
  const { openPreferences } = useCookieConsent();

  return (
    <div className={`${uiClasses.pageShell} lc-page-shell-footer`}>
      <div className="print:hidden">
        <AppMenu />
      </div>
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 print:max-w-none print:p-0">
        <PageErrorBoundary>{children ?? <Outlet />}</PageErrorBoundary>
      </main>
      <div className="print:hidden">
        <FeedbackButton />
      </div>
      <footer className="py-4 text-center space-x-3 print:hidden">
        <button
          type="button"
          onClick={openPreferences}
          className="text-sm text-gray-500 hover:underline hover:text-gray-700 transition-colors"
        >
          {t('footer.link')}
        </button>
        <span className="text-gray-300" aria-hidden="true">
          ·
        </span>
        <Link
          to="/cookie-policy"
          className="text-sm text-gray-500 hover:underline hover:text-gray-700 transition-colors"
        >
          {t('footer.policyLink')}
        </Link>
      </footer>
    </div>
  );
}
